<template>
    <main>
        <component :is="component" :gender="$route.params.gender"></component>
    </main>
</template>

<script>

import Register from "@/components/auth/Register";
import RegisterNew from "@/components/auth/RegisterNew";

export default {
    name: "RegisterPage",
    components: {
        RegisterNew,
        Register
    },
    data() {
        return {
            component: 'RegisterNew'
        }
    },
    beforeCreate() {
        if( ! this.$route.params.gender || ! ['man', 'woman'].includes(this.$route.params.gender))
            this.$router.push({name: 'home'})

    }
}
</script>

<style scoped lang="scss">

    main {
        min-height: 100dvh!important;
        position: relative;
        height: auto;

        @media(max-width: 991px) {

            .header-main {
                box-shadow: none;
                background-color: #fff;
            }
        }
    }

    .type {
        .nav-item {
            margin-left: 20px;
        }
    }
</style>